import React  from "react";
import { useParams } from 'react-router-dom';
import SalaryDeductionForm from "./components/SalaryDeductionForm";

const EditSalaryDeduction = () => {
	const { deductionId } = useParams();
    
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<SalaryDeductionForm recordId={deductionId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditSalaryDeduction;